import { inject } from '@angular/core';
import { NavigationService } from 'app/core/navigation/navigation.service';
// import { MessagesService } from 'app/layout/common/messages/messages.service';
// import { NotificationsService } from 'app/layout/common/notifications/notifications.service';
// import { QuickChatService } from 'app/layout/common/quick-chat/quick-chat.service';
// import { ShortcutsService } from 'app/layout/common/shortcuts/shortcuts.service';
import { forkJoin } from 'rxjs';
import { AuthService } from './core/auth/auth.service';
import { ResolveFn } from '@angular/router';

export const initialDataResolver: ResolveFn<any> = (route, state) => {
    const authService = inject(AuthService);
    const navigationService = inject(NavigationService);
    // const messagesService = inject(MessagesService);
    // const notificationsService = inject(NotificationsService);
    // const quickChatService = inject(QuickChatService);
    // const shortcutsService = inject(ShortcutsService);

    // Fork join multiple API endpoint calls to wait all of them to finish
    return forkJoin([
        // authService.verifySessionToken(state.url),
        authService.check(state.url),
        navigationService.get(),
        // messagesService.getAll(),
        // notificationsService.getAll(),
        // quickChatService.getChats(),
        // shortcutsService.getAll(),
    ]);
};
